import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from '../../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/nav-selector';

export const RoundNavItem = ( {
    updateNavSelection,
    rounds,
} ) => {
    const nav = useSelector( statsLeadersNavSelector );
    
    return (
        <Select
            items={ rounds }
            itemToString={ round => round.name }
            initialSelectedItem={ rounds.length && nav.round.id ? rounds.find( s => s.id === nav.round.id ) ?? '' : '' }
            activeItem={ rounds.length && nav.round.id ? rounds.find( s => s.id === nav.round.id ) ?? '' : '' }
            isReadyToRender={ () => rounds.length && nav.round.id && rounds.find( s => s.id === nav.round.id ) }
            label={ getTranslation( 'label.statsLeaders.nav.round' ) }
            onSelectedItemChange={ ( { selectedItem: round } ) => {
                updateNavSelection( 'round', round );
            } }
        />
    );
};

RoundNavItem.propTypes = {
    updateNavSelection: PropTypes.func.isRequired,
    rounds: PropTypes.array.isRequired
};